import InnerComponent from '@Components/Settings/ManageTeam';
import orgContainer from '@Components/AppContainer';

const ManageTeam = () => ((orgContainer(InnerComponent)));
export default ManageTeam;
